import { cn } from '@risksmart-app/atomic-ui';
import type { ReactNode } from 'react';
import { useEffect, useState } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

/**
 * Fades its children in (opacity 0 → 100, 150ms) on mount. Wraps each toolbar
 * tray/overflow action so that actions appearing when a tab's data loads in
 * (the tray is rebuilt as the active form publishes its config) fade in rather
 * than popping. Actions already on screen keep their identity (same React key)
 * and never re-fade — only freshly mounted ones animate.
 */
export const FadeIn = ({ children, className }: Props) => {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    setShown(true);
  }, []);

  return (
    <span
      className={cn(
        'inline-flex transition-opacity duration-150 ease-out',
        shown ? 'opacity-100' : 'opacity-0',
        className
      )}
    >
      {children}
    </span>
  );
};
